// Module
var code = "<template>\n    <select class=\"form-control\" ref=\"element\"></select>\n</template>";
// Exports
export default code;